import { Text, View } from 'react-native';

export default function Help() {
  return (
    <View>
      <Text>Help</Text>
    </View>
  );
}
